export enum BusinessLogicTimePeriods {
  Second,
  Minute,
  Hour,
  Day,
  Week,
  Month,
  Year,
}

export enum BusinessLogicTypes {
  // Calculations
  CalculationBracket = 0,
  CalculationPeriod = 1,
  CalculationPricePerUnit = 2,
  // Conditions
  ConditionArray = 12,
  ConditionBoolean = 3,
  ConditionDate = 4,
  ConditionNumeric = 5,
  ConditionSchedule = 6,
  ConditionString = 7,
  ConditionTimespan = 8,
  ConditionTariffValidity = 13,
  // Dependencies, currently only used in invoicing
  TariffDependency = 9,
  TariffGroupDependency = 10,
  AddressDependency = 11,
  // LineGrouping
  LineGrouping = 100,
  // VAT, currently only used in invoicing
  VATApplication = 255,
}
